import logoBlack from '../../assets/spotless-logo-black.png';

/** Shared Spotless AI letter-pad branding for PDF / print documents. */

export const COMPANY_NAME = 'Spotless AI';
export const TAGLINE = "world's first-ever AI-powered UVC disinfection-scoped";

export const CONTACT_EMAIL = 'info@spotless.ai';
export const CONTACT_PHONE = '7092022700';
export const WEBSITE = 'www.spotless.ai';
export const WEBSITE_URL = 'https://www.spotless.ai/';

export const LOGO_BLACK = logoBlack;
/** @deprecated use LOGO_BLACK */
export const LOGO_WHITE = logoBlack;

/** Spotbot Lite (transparent / no black plate) — same asset used across Flutter dashboard. */
export const ROBOT_IMAGE_URL =
  'https://robot-images-flutter-dashboard.s3.ap-south-1.amazonaws.com/images/e99c3964-6dce-4107-b27d-0c3b49b2877e-Spotbot-Lite.png';
export const ROBOT_IMAGE = ROBOT_IMAGE_URL;

/**
 * Matches ReportsPage Open / Generate certificate button:
 * theme.gradients.primary = linear-gradient(to right, #3B82F6 0%, #EC4899 100%)
 */
export const COLORS = {
  blue: '#3B82F6',
  pink: '#EC4899',
  violet: '#7C3AED',
  ink: '#0f172a',
  slate: '#64748b',
  white: '#FFFFFF',
};

export const COLORS_RGB = {
  blue: [59, 130, 246],
  pink: [236, 72, 153],
  violet: [124, 58, 237],
  ink: [15, 23, 42],
  slate: [100, 116, 139],
  white: [255, 255, 255],
};

/** A4 letter-pad layout in mm (jsPDF). */
export const LAYOUT_MM = {
  pageWidth: 210,
  pageHeight: 297,
  headerHeight: 50,
  footerHeight: 22,
  sideMargin: 16,
  /** Body starts below header chrome (clears large robot). */
  contentTop: 58,
  contentBottom: 272,
};

export function footerContactLine() {
  return `${CONTACT_EMAIL}  ·  ${CONTACT_PHONE}  ·  ${WEBSITE}`;
}

export const WAVE_SVG =
  'M0,22 C40,6 70,34 105,18 C145,2 175,30 210,12 L210,40 L0,40 Z';
